import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link } from "react-router-dom";
import {  GetHotList,  jobDetailsEmailTemplatefromJobPosts,  rtrEmailTemplate,  SendPostJobJobDetailsToBenchSalesOrCandidate, SendPostJobRTRMail, siteURL } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";
import parse from "html-react-parser";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
const ShareJobDetailstoBenchSales = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting }, getValues, reset } = useForm({
    defaultValues: {
      vendorGuid: [],
      vendorEmail: "",
      vendorName: "",
      jobPost: null,
      jobDescription: ""
    }
  });
   const navigate = useNavigate();
 
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedCountry } = useCountry();
const [tierFilter, setTierFilter] = useState('');

  const userguid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const roleID = localStorage.getItem("roleID");
   const Guid = roleID == 3 ? employerGuid : userguid;
  const token = localStorage.getItem("jwtToken");
  const [pageCount, setPageCount] = useState(0);
  const emailOptions = JSON.parse(localStorage.getItem("emailOptions") || "{}");
const email = localStorage.getItem("email");
const mobileNumber = localStorage.getItem("mobileNumber");
  const [subvendors, setSubvendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(8);
  const [selectedJobs, setSelectedJobs] = useState([]);
const [billRate, setBillRate] = useState("");
const [candidateName, setCandidateName] = useState("");
const [previewHTML, setPreviewHTML] = useState("");
const [showPreview, setShowPreview] = useState(false);
 const payRatePlaceholder = selectedCountry == 1 ? 'Enter Current CTC' : 'Enter Pay Rate';
 const [searchTerm, setSearchTerm] = useState("");
const handleTierFilterChange = (e) => {
  setTierFilter(e.target.value);
};

const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    };
  useEffect(() => {
 const fetchSubvendors = async () => {
  setLoading(true);
  try {
    const response = await Axios.get(
      `${GetHotList.APIURL}?UserGuid=${userguid}&countryId=${selectedCountry}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // ✅ Strictly match type and active flag
    let benchSalesOnly = [];
    if(emailOptions.sendRTR){
      benchSalesOnly = response.data;
    }
    else if(emailOptions.sendJobDetails){
    benchSalesOnly = response.data?.filter((x)=>x.type=='BenchSales'&& x.isActive == true)
    }
    setSubvendors(benchSalesOnly);
     setPageCount(Math.ceil(benchSalesOnly.length / itemsPerPage));

    console.log("Filtered BenchSales:", benchSalesOnly); // ✅ debug log
  } catch (error) {
    console.error('Error fetching subvendor data:', error);
  } finally {
    setLoading(false);
  }
};



    if (isAccordionOpen && Guid && selectedCountry) {
      fetchSubvendors();
    }
  }, [isAccordionOpen, Guid, selectedCountry]);

  useEffect(() => {
  const jobDetails = localStorage.getItem("selectedJobPostDetails");
  if (jobDetails) {
    try {
      const parsedJobs = JSON.parse(jobDetails);
      setSelectedJobs(parsedJobs);
   const initialRate = parsedJobs[0]?.payRate || "";
const formattedRate = initialRate.toLowerCase().includes("knackhook")
  ? initialRate
  : `${initialRate}`;

setBillRate(formattedRate);
    } catch (e) {
      console.error("Error parsing selected job post details from localStorage", e);
    }
  }
}, []);



  const safeValue = (val) => (val === "null" ||val === null || val === undefined ? "" : val);

const filteredSubvendors = subvendors.filter((v) => {
  const matchesTier = tierFilter ? v.tierType === tierFilter : true;
  const matchesSearch = `${v.name} ${v.emailId}`.toLowerCase().includes(searchTerm.toLowerCase());
  return matchesTier && matchesSearch;
});

// Slice for pagination
const offset = currentPage * itemsPerPage;
const currentPageVendors = filteredSubvendors.slice(offset, offset + itemsPerPage);

// Update page count based on filtered results
useEffect(() => {
  setPageCount(Math.ceil(filteredSubvendors.length / itemsPerPage));
}, [filteredSubvendors]);

const handleTogglePreview = () => {
  const emailOptions = JSON.parse(localStorage.getItem("emailOptions") || "{}");

  if (!showPreview) {
    const job = selectedJobs[0];
const commonData1 = {
      candidateName :selectedVendors[0]?.name,
      jobTitle: job.title,
      location: job.location,
      jobType: job.jobType,
      jobDescription: job.jobDescription,
      candidateMobileNumber: mobileNumber,
      senderEmail:email,
      billRate,
      submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`,
      endClientName: job.endClient
    };
    const commonData = {
      candidateName:candidateName,
      jobTitle: job.title,
      location: job.location,
      jobType: job.jobType,
      jobDescription: job.jobDescription,
      endClientName: job.endClient,
      candidateMobileNumber: mobileNumber,
      senderEmail:email,
      billRate,
      submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`,
      recruiterName:selectedVendors[0]?.name,
    };
  let html = "";

    if (emailOptions.sendRTR) {
      html = rtrEmailTemplate(commonData);
    } else if (emailOptions.sendJobDetails) {
      html = jobDetailsEmailTemplatefromJobPosts(commonData1);
    } else {
      // bulk candidate emails
      const candidateEmails = getValues("candidateEmails") || "";

      html = jobDetailsEmailTemplatefromJobPosts({
        ...commonData1,
        candidateName: "Candidate",
        candidateEmails, // pass raw emails so template can show
      });
    }


    setPreviewHTML(html);
  }

  setShowPreview(prev => !prev);
};

  const onSubmit = async (data, e) => {
  e.preventDefault();

  // ✅ Prepare vendors list
  let selectedVendorList = [];

  if (emailOptions.sendRTR || emailOptions.sendJobDetails) {
    // staffing contacts
    selectedVendorList = selectedVendors.map(v => ({
      email: v.emailId,
      name: v.name,
    }));
  } else {
    // bulk candidate emails
    const rawEmails = data.candidateEmails || "";
    const emailArray = rawEmails
      .split(",")
      .map(e => e.trim())
      .filter(e => e); // remove empty

    selectedVendorList = emailArray.map(e => ({
      email: e,
      name: "Candidate", // default name
    }));
  }

  // ✅ Show alert if no vendors selected
  if (selectedVendorList.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Please select at least one recipient to share.",
      showConfirmButton: true,
    });
    return; // ⛔ Prevent the API call
  }

  reset();
  setIsLoading(true);
 const jobPostID = selectedJobs.length === 1 ? selectedJobs[0]?.jobPostID.toString() : "null";
   const job = selectedJobs[0]; 
  try {
    // ✅ Prepare candidate list
    if (emailOptions.sendJobDetails) {
    const jobList = selectedJobs.map(job => ({
     title: safeValue(job.title),
      location: safeValue(job.location),
      type: safeValue(job.jobType),
     description: safeValue(job.jobDescription),
     endClientName:safeValue(job.endClient),
     billRate:safeValue(job.payRate)
    }));

      const payload = {
        vendors: selectedVendorList,
        senderEmail: email,
        phoneNumber: mobileNumber,
        userGuid: userguid,
        guid: userguid,
        jobs: jobList,
        jobPostID: jobPostID
      };

      const result = await Axios.post(SendPostJobJobDetailsToBenchSalesOrCandidate.APIURL, payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

    if (result.data.message === "All job emails sent successfully.") {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Email sent Successfully",
        showConfirmButton: false,
        timer: 5000,
      });
      navigate("/Employer/ListOfJobPosts");
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Add correct Details",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  } 

else if (emailOptions.sendRTR)  {
  if (!candidateName || candidateName.trim() === "") {
  Swal.fire({
    icon: 'warning',
    title: 'Please enter Candidate Name.',
    showConfirmButton: true,
  });
    return; // ⛔ Prevent the API call
  }
   const payload = {
        userGuid: userguid,
        vendors: selectedVendorList,
        positionTitle: safeValue(job.title),
        location: safeValue(job.location),
        employmentType: safeValue(job.jobType),
        endClientName: safeValue(job.endClient),
        senderEmail: email,
        phoneNumber:mobileNumber,
        billRate: billRate, // fill if you have
        submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`, // fill if you have/AddCandidate?uGuid=3fa85f64-5717-4562-b3fc-2c963f66afa6&CountryID=2
        jobDescription: safeValue(job.jobDescription),
        jobOpenings: job.jobPositions, // or from job.jobOpenings if available
        candidateName: candidateName,
        jobPostID: jobPostID
      };

      const result = await Axios.post(SendPostJobRTRMail.APIURL, payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (result.data.message?.includes("success")) {
        Swal.fire({ icon: "success", title: "RTR Email sent", showConfirmButton: false, timer: 3000 });
        navigate("/Employer/ListOfJobPosts");
        localStorage.removeItem("emailOptions");
        localStorage.removeItem("selectedJobPostDetails");
      } else {
        Swal.fire({ icon: "error", title: "Failed to send RTR Email", showConfirmButton: true });
      }
    }

    // ✅ CASE 3: Send Candidate Emails (bulk)
    else if (emailOptions.sendCandidateMail) {
      const payload = {
        vendors: selectedVendorList, // candidate emails
        senderEmail: email,
        phoneNumber: mobileNumber,
        userGuid: userguid,
        guid:userguid,
        jobPostID: jobPostID,
        jobs: [
          {
            title: safeValue(job.title),
            location: safeValue(job.location),
            type: safeValue(job.jobType),
            description: safeValue(job.jobDescription),
            endClientName:safeValue(job.endClient),
            billRate:safeValue(job.payRate)
          },
        ],
      };

      const result = await Axios.post(SendPostJobJobDetailsToBenchSalesOrCandidate.APIURL, payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (result.data.message?.includes("success")) {
        Swal.fire({
          icon: "success",
          title: "Candidate Emails sent successfully",
          showConfirmButton: false,
          timer: 3000,
        });
        navigate("/Employer/ListOfJobPosts");
        localStorage.removeItem("emailOptions");
        localStorage.removeItem("selectedJobPostDetails");
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send Candidate Emails",
          showConfirmButton: true,
        });
      }
    }
  } catch (error) {
    console.log("Error sending email", error);
    Swal.fire({
      icon: "error",
      title: "Something went wrong while sending email",
      showConfirmButton: true,
    });
  } finally {
    setIsLoading(false);
  }
};



 const [selectAll, setSelectAll] = useState(false);

  // When "Select All" is toggled
 const handleSelectAll = (e) => {
  const checked = e.target.checked;
  setSelectAll(checked);

  if (checked) {
    // ✅ Select all from filtered list, not just paginated
    setSelectedVendors([...filteredSubvendors]);
  } else {
    // ❌ Clear all
    setSelectedVendors([]);
  }
};


const [selectedVendors, setSelectedVendors] = useState([]);
const handleCheckboxChange = (vendor, checked) => {
  let updated = checked
    ? [...selectedVendors, vendor]
    : selectedVendors.filter((v) => v.hotListID !== vendor.hotListID);

  setSelectedVendors(updated);

  const allSelected = filteredSubvendors.every((v) =>
    updated.some((s) => s.hotListID === v.hotListID)
  );
  setSelectAll(allSelected);
};


  // Reset when subvendor list changes
  useEffect(() => {
    setSelectedVendors([]);
    setSelectAll(false);
  }, [subvendors]);

  // Check if a vendor is selected
 const isVendorSelected = (vendorId) =>
  selectedVendors.some((v) => v.hotListID === vendorId);

  return (
    <ConsultantLayout>
      <section>
        {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <div className="container-fluid mt-4 pb-5">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center flex-1">
                <Link to="/Employer/ListOfJobPosts">
                  <i className="fa fa-arrow-left me-2" style={{color: "#00a7ac", fontSize: 16 }} />
                </Link>
                <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px' }}>
   Share Job Details to Staffing Contact
  </h2>

              </div>
            </div>

            <hr />

{(emailOptions.sendRTR || emailOptions.sendJobDetails) && (
    <div className="accordion" id="subvendorAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header"   >
          <button
            className={`accordion-button ${!isAccordionOpen ? 'collapsed' : ''}`}
            type="button"
            style={{ color: "#00a7ac" }}
            onClick={() => setIsAccordionOpen(prev => !prev)}
          >
            Staffing Contact Details
          </button>
        </h2>
        <div
          className={`accordion-collapse collapse ${isAccordionOpen ? 'show' : ''}`}
          aria-labelledby="headingOne"
        >
        <div className="accordion-body">
  {loading ? (
    <p>Loading staffing contacts...</p>
  ) : (
    <>
      {/* Search and Filter Row */}
      <div className="d-flex justify-content-between mb-3">
        {/* Search Input */}
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: '200px' }}
          placeholder="Search by name or email"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(0); // reset to first page on search
          }}
        />

        {/* Tier Filter */}
        <div className="d-flex align-items-center gap-1">
          <span style={{ fontSize: '12px' }}>Tier Type</span>
          <select
            value={tierFilter}
            onChange={handleTierFilterChange}
            className="form-select form-select-sm"
            style={{ width: '150px', fontSize: '12px', marginLeft: 5 }}
            title="Filter Tier"
          >
            <option value="">All</option>
            <option value="Tier 1">Tier 1</option>
            <option value="Tier 2">Tier 2</option>
            <option value="Tier 3">Tier 3</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <table
        className="table"
        style={{
          minWidth: "100%",
          fontSize: "12px",
          marginBottom: "12px",
          wordWrap: "break-word",
        }}
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Company</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Tier Type</th>
            <th>
              Actions
              <span className="ms-2">
                Select All
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  title="Select All"
                  style={{ marginLeft: 5 }}
                />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {currentPageVendors.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No staffing contacts found.
              </td>
            </tr>
          ) : (
            currentPageVendors.map((vendor, index) => (
              <tr key={vendor?.id || index}>
                <td>{vendor.name || '-'}</td>
                <td>{vendor.company || '-'}</td>
                <td>{vendor.emailId || '-'}</td>
                <td>{vendor.phone || '-'}</td>
                <td>{vendor.tierType || '-'}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={isVendorSelected(vendor.hotListID)}
                    onChange={(e) => handleCheckboxChange(vendor, e.target.checked)}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {currentPageVendors.length > 0 && (
        <div className="mt-3">
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        </div>
      )}
    </>
  )}
</div>

        </div>
      </div>
    </div>
)}
{!(emailOptions.sendRTR || emailOptions.sendJobDetails) && (
  <div className="row mb-3 mt-3">
    <div className="col-md-12">
      <h5 style={{ color: "#00a7ac" }}>Candidate Emails (comma separated)</h5>
      <textarea
        className="form-control mt-4"
        placeholder="Enter candidate emails separated by commas"
        rows={3}
        {...register("candidateEmails", { required: true })}
      />
    </div>
  </div>
)}


            <div className="card shadow-lg mt-5 p-5 border-0">
              <form onSubmit={handleSubmit(onSubmit)}>
        {emailOptions.sendRTR &&    <div className="row mb-3">
  <div className="col-md-6">
 <h5 style={{ color: "#00a7ac" }}>Candidate Name</h5>
    <input
      type="text"
      className="form-control"
      placeholder="Enter candidate name"
      value={candidateName}
      onChange={(e) => setCandidateName(e.target.value)}
    />
  </div>
  <div className="col-md-6">
    <h5 style={{ color: "#00a7ac" }}>{selectedCountry == 1 ? ' Current CTC' : 'Pay Rate'}</h5>
    <input
      type="text"
      className="form-control"
      placeholder={payRatePlaceholder}
      value={billRate}
      onChange={(e) => setBillRate(e.target.value)}
    />
  </div>
</div> }
<OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>From Email</Tooltip>
  )}
>
  <input
    type="email"
    {...register("clientemail", { required: "From Email is required" })}
    placeholder="From Email"
    defaultValue={email}
    className={`form-control basic-form mt-3 ${errors.clientemail ? 'is-invalid' : ''}` }
  />
</OverlayTrigger>
            
                {/* Candidate Table */}
                <div className="col-12 mt-4" style={{ overflowX: "auto", width: "100%" }}>

               {selectedJobs.length > 0 && (
  <div className="col-12 mt-4" style={{ overflowX: "auto", width: "100%" }}>
    <h5 style={{ color: "#00a7ac" }}>Selected Job Details</h5>
    <table className="table table-bordered" style={{ fontSize: "12px" }}>
      <thead>
        <tr>
          <th>Job Title</th>
          <th>Location</th>
          <th>Job Type</th>
          <th>Job Role</th>
          <th>Job Description</th>
        </tr>
      </thead>
      <tbody>
        {selectedJobs.map((job, index) => (
          <tr key={index}>
            {/* Job Title */}
            <td>
             

              {job.title}

             
            </td>

           
            <td>
               {job.location}
            </td>

       
            <td>
                {job.jobType} 
            </td>

           
            <td>
            {job.jobRole}   
            </td>
            <td>
            <span  dangerouslySetInnerHTML={{ __html: safeValue(job.jobDescription) }}></span>  
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

                </div>

                <div className="row mb-4 mt-3">
                  <div className="col-12 text-end">
                <button type="button" onClick={handleTogglePreview} className="btn btn-primary mr-2">
                {showPreview ? "Hide Preview" : "Show Preview"}
                </button>
                  
                    <button type="submit" disabled={isSubmitting || isDisabled} className="btn btn-primary mr-2">
                      {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
                      Share
                    </button>
                      <Link to="/Employer/ListOfJobPosts">
                    
                      <button type="button" disabled={isSubmitting || isDisabled} className="btn btn-secondary">
                        Cancel
                      </button>
                    </Link>
                  
  </div>
                </div>
              </form>
              {showPreview && (
  <div className="mt-3 p-3 border rounded bg-light" style={{ maxHeight: 400, overflowY: "auto" }}>
    {parse(previewHTML)}
  </div>
)}
            </div>
          </div>
        )}
      </section>
    </ConsultantLayout>
  );
};

export default ShareJobDetailstoBenchSales;
